__turbopack_context__.v({
  "cartDetails": "cart-aside-module__xmAE3a__cartDetails",
  "cartLines": "cart-aside-module__xmAE3a__cartLines",
  "cartMain": "cart-aside-module__xmAE3a__cartMain",
  "closeButton": "cart-aside-module__xmAE3a__closeButton",
  "commerceMessages": "cart-aside-module__xmAE3a__commerceMessages",
  "header": "cart-aside-module__xmAE3a__header",
  "headerTitle": "cart-aside-module__xmAE3a__headerTitle",
  "itemCount": "cart-aside-module__xmAE3a__itemCount",
  "staleNotice": "cart-aside-module__xmAE3a__staleNotice",
  "title": "cart-aside-module__xmAE3a__title",
});
